import { atom } from 'jotai';

const deletedEntityAtom = atom('');

export { deletedEntityAtom };